import { render } from "./languageTranslation.vue?vue&type=template&id=1ad53bff&scoped=true"
import script from "./languageTranslation.vue?vue&type=script&lang=js"
export * from "./languageTranslation.vue?vue&type=script&lang=js"

import "./languageTranslation.vue?vue&type=style&index=0&id=1ad53bff&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad53bff"]])

export default __exports__